export const videoTypes = ['MOV', 'MP4', 'WEBM'];
export const imageTypes = ['JPG', 'JPEG', 'JFIF', 'WEBP', 'PNG', 'GIF', 'BLOB'];
